__turbopack_context__.v({
  "arrow": "PgDuaa_arrow",
  "button": "PgDuaa_button",
  "container": "PgDuaa_container",
  "inner": "PgDuaa_inner",
  "left": "PgDuaa_left",
  "menu": "PgDuaa_menu",
  "menuItem": "PgDuaa_menuItem",
  "name": "PgDuaa_name",
  "right": "PgDuaa_right",
  "ssn": "PgDuaa_ssn",
});
